import React from "react";
import Layout from "../../components/layout/Layout";
import ProfileCard from "../../components/users/ProfileCard";
import styles from "./ProfilePage.module.css";

const ProfilePage = () => (
  <Layout>
    <main className={styles.page}>
      <ProfileCard />
    </main>
  </Layout>
);

export default ProfilePage;
